import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Button, DynamicSvg, InfoTag, Typography, getTestId, isValidObject, tokens, useBreakpoint } from '@airtel/air-design-system';
import { Image, View } from 'react-native';
import { getCompareBenefitItemStyles } from './CompareBenefitStyles';
var ComparePlanBenefitItem = props => {
  var benefitAccessibilityProps = props.benefitAccessibilityProps,
    showDivider = props.showDivider,
    _props$isIconTitle = props.isIconTitle,
    isIconTitle = _props$isIconTitle === void 0 ? false : _props$isIconTitle,
    _props$isHyperLinkTit = props.isHyperLinkTitle,
    isHyperLinkTitle = _props$isHyperLinkTit === void 0 ? false : _props$isHyperLinkTit,
    hyperLinkActionMetaData = props.hyperLinkActionMetaData,
    subHeading = props.subHeading,
    _props$subHeadingNumb = props.subHeadingNumberOfLines,
    subHeadingNumberOfLines = _props$subHeadingNumb === void 0 ? 2 : _props$subHeadingNumb,
    heading = props.heading,
    _avatarProps = props.avatarProps,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$id = props.id,
    id = _props$id === void 0 ? '' : _props$id,
    avatarIcon = props.avatarIcon,
    avatarImgUrl = props.avatarImgUrl,
    avatarNoBgContainer = props.avatarNoBgContainer,
    onUserAction = props.onUserAction,
    imgStyle = props.imgStyle,
    benefitImageUrl = props.benefitImageUrl,
    style = props.style,
    title = props.title,
    metaInfoTag = props.metaInfoTag,
    metaInfoTagType = props.metaInfoTagType,
    showIcon = props.showIcon,
    iconName = props.iconName,
    iconProps = props.iconProps,
    _props$titleNumberOfL = props.titleNumberOfLines,
    titleNumberOfLines = _props$titleNumberOfL === void 0 ? 2 : _props$titleNumberOfL,
    _props$headingNumberO = props.headingNumberOfLines,
    headingNumberOfLines = _props$headingNumberO === void 0 ? 2 : _props$headingNumberO,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ComparePlanBenefitItem' : _props$testID;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var containerStyle = getCompareBenefitItemStyles(props, isLargeScreen);
  var showAvatarType = avatarIcon ? 'iconName' : 'imageUrl';
  var avatarProps = Object.assign({
    noBgContainer: avatarNoBgContainer,
    size: isLargeScreen ? 'md' : 'xs',
    variant: avatarIcon ? 'icon' : 'image',
    [showAvatarType]: avatarIcon || avatarImgUrl
  }, _avatarProps);
  var isBenefitAccessibilityPropsValidObject = isValidObject(benefitAccessibilityProps);
  var onLinkCTAPress = () => {
    hyperLinkActionMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, hyperLinkActionMetaData), Object.assign({}, props)));
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(View, Object.assign({
      style: [containerStyle.compareBenefitItemContainer, style]
    }, getTestId(testID), benefitAccessibilityProps, {
      children: [benefitImageUrl && _jsx(Image, Object.assign({
        source: {
          uri: benefitImageUrl
        },
        style: [containerStyle.avatarStyles, imgStyle]
      }, getTestId(testID, 'benefitImage'))), _jsxs(View, Object.assign({
        style: containerStyle.container
      }, {
        children: [!!isIconTitle && _jsx(Avatar, Object.assign({}, avatarProps, getTestId(testID, 'avatar'))), !!showIcon && !!iconName && _jsx(DynamicSvg, Object.assign({
          iconName: iconName,
          fontSize: isLargeScreen ? tokens.spacing.SPACING_32 : tokens.spacing.SPACING_24
        }, iconProps, getTestId(testID, 'icon'))), !!isHyperLinkTitle && _jsx(Button, Object.assign({
          buttonType: "tertiary",
          controlState: "none",
          iconPosition: "left",
          size: isLargeScreen ? 'md' : 'sm',
          disabled: disabled,
          theme: "light",
          title: heading,
          version: "fixed-padding",
          onPress: onLinkCTAPress
        }, getTestId(testID, 'cta'), props === null || props === void 0 ? void 0 : props.accessibilityProps)), !!title && !isHyperLinkTitle && _jsx(Typography, {
          style: containerStyle.headerText,
          text: title,
          numberOfLines: titleNumberOfLines,
          type: isLargeScreen ? 'body-para-md' : 'body-para-sm',
          accessible: !isBenefitAccessibilityPropsValidObject
        }), !!heading && !isHyperLinkTitle && _jsx(Typography, Object.assign({
          style: containerStyle.headerText,
          text: heading,
          numberOfLines: headingNumberOfLines,
          type: isLargeScreen ? 'body-para-md-bold' : 'body-para-sm-bold'
        }, getTestId(testID, 'headingText'), {
          accessible: !isBenefitAccessibilityPropsValidObject
        })), !!subHeading && _jsx(Typography, Object.assign({
          style: containerStyle.subHeaderText,
          text: subHeading,
          numberOfLines: subHeadingNumberOfLines,
          type: isLargeScreen ? 'body-para-md' : 'body-para-xs'
        }, getTestId(testID, 'subHeadingText'), {
          accessible: !isBenefitAccessibilityPropsValidObject
        })), !!metaInfoTag && _jsx(InfoTag, {
          style: containerStyle.infoTag,
          size: isLargeScreen ? 'md' : 'sm',
          type: "inline",
          subType: metaInfoTagType,
          text: metaInfoTag
        })]
      }))]
    })), !!showDivider && _jsx(View, {
      style: containerStyle.spacerContainer
    })]
  });
};
export default ComparePlanBenefitItem;